import React from 'react';

const InsertIcon = () => {
  return (
    <svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33.876 22.445a.808.808 0 0 1-.808.804h-8.885v8.839a.807.807 0 0 1-1.615 0v-8.839h-8.885a.805.805 0 0 1-.807-.803c0-.442.361-.804.807-.804h8.885v-8.839c0-.444.361-.803.808-.803.446 0 .807.36.807.803v8.839h8.885c.444 0 .808.362.808.803z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InsertIcon;
